<div class="form-header">
	<h2 class="ud-heading-xl">Photo</h2>
	<p>Add a nice photo of yourself for your profile.</p>
</div>


<div>

	<div class="form-container image-upload-preview-with-crop--preview-wrapper--3mrme ">
		<div class="image-upload-preview-with-crop--image-wrapper--2soBW">
			<img [src]="profile_picture" alt="profile_picture" *ngIf="!isLoading">
		</div>

	</div>

	<!-- <div class="file-upload">
        <input type="file" (change)="onFileSelected($event)" accept="image/*">
      </div> -->

	<div class="ud-form-group">
		<label for="form-group--3" class="ud-form-label ud-heading-sm">Add/Change Image</label>
		<div class="file-uploader-module--file-uploader-large--FNHTd">
			<input accept=".gif,.jpg,.jpeg,.png" id="form-group--3" type="file" class="ud-sr-only"
				(change)="onFileSelected($event)">
			<label for="form-group--3"
				class="file-uploader-module--input-group--3zr1g file-uploader-module--uploader-label--3t4Ob">
				<span class="file-uploader-module--fake-input--1Uwbh">
					<span class="file-uploader-module--fake-input-text--2n1U1">No file selected</span>
				</span>
				<span class="ud-btn ud-btn-large ud-btn-secondary ud-heading-md file-uploader-module--btn--1qeQX">
					<span>Upload image</span>
				</span>
			</label>

		</div>
	</div>
	<!-- 
      <app-rvhost-loader></app-rvhost-loader> -->
	<!--     
      <app-rvhost-loader *ngIf="isLoading"></app-rvhost-loader> -->


	<button type="button" (click)="onSaveButtonClick()" style="margin-left:16%;margin-top:15px"
		class="btn btn-primary">Save</button>
</div>